import React, { Component } from "react";
import ReactDOM from "react-dom";
import Dropdown from "react-bootstrap/Dropdown";
import {
  alert,
  toFixed,
  format_date,
  GET,
  PUT,
  loading,
  StatusTnx,
  Select,
} from "../../components/CustomComponent.js";

// Small circular ✓ / ✕ badge, matching the Settlement HQ page style.
const VerifyBadge = ({ ok }) => (
  <span
    className={ok ? "text-success" : "text-danger"}
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: "22px",
      height: "22px",
      borderRadius: "50%",
      fontSize: "14px",
      fontWeight: "bold",
      backgroundColor: ok ? "#e9f9ef" : "#fdecec",
      border: `1px solid ${ok ? "#198754" : "#dc3545"}`,
    }}
  >
    {ok ? "✓" : "✕"}
  </span>
);

export default class SettlementHqApprove extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_currency: "THB",
      filter_data_search: "",
      filter_broker: "",
      data_broker: [],
      data: [],
    };
  }

  componentDidMount() {
    this.GetMaster();
    this.Get();
  }

  // Fetch pending HQ settlements, then keep only rows that are NOT fully
  // verified yet (at least one of wallet / password / 2FA is still false).
  // ตัวเลือกของ dropdown ทั้งหน้า ไม่เปลี่ยนระหว่างอยู่บนหน้านี้ ดึงครั้งเดียวตอนเปิดหน้า
  // ไม่ยุ่งกับ loading เพราะ Get เป็นคนคุมสถานะโหลดของตาราง
  GetMaster = async () => {
    let data_broker = [];
    const [result_broker] = await Promise.all([
      GET("v1/admin/brokers/options", {
        page_size: 100000,
        page: 0,
        data_search: "",
      }),
    ]);
    if (result_broker?.status) {
      data_broker = result_broker.data.map((e) => ({
        value: e.uid,
        label: e.name_en,
      }));
    }
    this.setState({ data_broker });
  };
  Get = async () => {
    const { filter_currency, filter_data_search, filter_broker } = this.state;
    loading(true);
    const [result] = await Promise.all([
      GET("transactions/withdrawals/list", {
        page_size: 100,
        page: 1,
        data_search: filter_data_search,
        filter_status: "pending",
        process_type: "withdrawals",
        currency: filter_currency,
        broker_id: filter_broker,
        is_hq: true,
      }),
    ]);

    let data = [];
    if (result?.status) {
      data = (result.data || []).filter(
        (item) =>
          !(
            item.settlement?.is_wallet_address_verify &&
            item.settlement?.is_password_verify &&
            item.settlement?.is_2fa_verify
          ),
      );
    }

    this.setState({ data });
    loading(false);
  };

  ApproveVerify = async (item) => {
    if (
      await alert(
        "",
        "warning",
        "Confirm",
        `Approve all verifications (Wallet / Pass / 2FA) for RefNo ${item.ref_no}?`,
        "Approve",
        "Cancel",
      )
    ) {
      loading(true);
      const result = await PUT(
        `transactions/withdrawals/approve-verify-dev/${item.uid}`,
        { approve: true },
      );
      loading(false);
      if (result?.status === true) {
        alert("", "success", "Success", "Approved all verifications successfully.");
        this.Get();
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again.",
        );
      }
    }
  };

  render() {
    const { data, filter_currency, filter_data_search, filter_broker, data_broker } =
      this.state;
    // Filter: ถ้า Developer Mode ส่งช่องใน hero มา จะ portal ขึ้นไปวางในหัว hero
    const filter = (
        <div className={`ar-toolbar ar-filter ${this.props.filterSlot ? "mt-3" : "mb-3"}`}>
          <div className="ar-filter-head">
            <span className="ar-toolbar-label">
              <span className="icon me-2">{"\uf0b0"}</span>Filter
            </span>
          </div>
          <div className="ar-filter-row">
            <div className="ar-filter-field ar-filter-field-search">
              <span className="ar-filter-label">Search</span>
          <input
            type="text"
            className="form-control"
            placeholder="Refno..."
            value={filter_data_search}
            onChange={(e) => this.setState({ filter_data_search: e.target.value })}
            onKeyUp={(e) => {
              if (e.key === "Enter") this.Get();
            }}
          />
            </div>
            <div className="ar-filter-field">
              <span className="ar-filter-label">Broker</span>
            <Select
              className="form-control"
              placeholder="Broker..."
              options={data_broker}
              onChange={(e) => this.setState({ filter_broker: e })}
              value={filter_broker}
            />
            </div>
          <div className="ar-toolbar-actions">
          <button className="ar-btn-gold" onClick={() => this.Get()}>
            <span className="icon me-2">{"\uf002"}</span>Search
          </button>
          </div>
          </div>
          <div className="ar-filter-foot">
          {["THB", "LAK"].map((cur) => (
            <button
              key={cur}
              className={`ar-pill ${cur === filter_currency ? "active" : ""}`}
              onClick={() =>
                this.setState({ filter_currency: cur }, () => this.Get())
              }
            >
              {global.currency?.find((c) => c.currency_code === cur)?.image}
              <span className="ms-1">{cur}</span>
            </button>
          ))}
          </div>
        </div>
    );
    return (
      <div>
        {this.props.filterSlot ? ReactDOM.createPortal(filter, this.props.filterSlot) : filter}

        {/* Table */}
        <div className="ar-table-card">
          <div className="ar-table-head flex-wrap gap-2">
            <div>
              <div className="ar-table-title">
                <span className="icon me-2 pu-title-icon">{"\uf560"}</span>
                Pending approvals
              </div>
              <div className="ar-table-caption">
                {data.length > 0 ? `Showing ${data.length} item${data.length > 1 ? "s" : ""}` : "No results"}
                <span className="ms-2">
                  &middot; pending & not fully verified — Approve sets Wallet / Pass / 2FA to verified
                </span>
              </div>
            </div>
            <div className="d-flex align-items-center flex-wrap gap-2">
              <button type="button" className="pu-om-ctl" onClick={() => this.Get()} title="Refresh">
                <span className="icon me-1">{"\uf2f1"}</span>Refresh
              </button>
            </div>
          </div>
        <div className="table-responsive" style={{ minHeight: 200 }}>
          <table className="table table-hover ar-table pu-table pu-table-compact">
            <thead>
              <tr>
                <td className="text-nowrap">Time</td>
                <td className="text-nowrap">RefNo</td>
                <td className="text-nowrap">Broker</td>
                <td className="text-nowrap text-end">Amount</td>
                <td className="text-nowrap text-center">Wallet Verify</td>
                <td className="text-nowrap text-center">Pass Verify</td>
                <td className="text-nowrap text-center">2FA Verify</td>
                <td className="text-nowrap text-center">Status</td>
                <td className="text-nowrap text-center td-actions">Actions</td>
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan={9} className="text-center text-secondary py-4">
                    No items to approve
                  </td>
                </tr>
              ) : (
                data.map((item, index) => (
                  <tr key={`row-${index}`}>
                    <td className="text-nowrap">
                      {format_date(item.created_at, "dd/mm/yy hh:mm:ss", "en")}
                    </td>
                    <td className="text-nowrap">{item.ref_no}</td>
                    <td className="text-nowrap">
                      {item.broker?.name_en || item.broker?.name_th || "-"}
                    </td>
                    <td className="text-nowrap text-end text-success">
                      {toFixed(item.amount, 2)}
                    </td>
                    <td className="text-nowrap text-center">
                      <VerifyBadge ok={!!item.settlement?.is_wallet_address_verify} />
                    </td>
                    <td className="text-nowrap text-center">
                      <VerifyBadge ok={!!item.settlement?.is_password_verify} />
                    </td>
                    <td className="text-nowrap text-center">
                      <VerifyBadge ok={!!item.settlement?.is_2fa_verify} />
                    </td>
                    <td className="text-nowrap text-center">
                      <div className="d-flex align-items-center justify-content-center">
                        {StatusTnx(item.status)}
                      </div>
                    </td>
                    <td className="text-nowrap text-center td-actions">
                      <Dropdown align="end">
                        <Dropdown.Toggle className="pu-action-toggle" id={`settlement-approve-actions-${index}`}>Action</Dropdown.Toggle>
                        <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                          <Dropdown.Item className="pu-action-item" onClick={() => this.ApproveVerify(item)}>
                            <span className="icon">{""}</span>Approve
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        </div>
      </div>
    );
  }
}
